import { Tooltip } from '@77sol-ui/molecules'
import styled from 'styled-components'

export const StyledTooltipContent = styled(Tooltip.Content)`
  z-index: 999999;
  max-width: 400px;
  line-height: 20px;
`
